module.exports = __webpack_public_path__ + "img/merchant_qrcode.8e66fa0c.svg";